import BaseClient from '@/app/model/api/response/baseApiClient'

class PlantingRecordsApi extends BaseClient {
  public getPlantingRecords (id: string) {
    const path = '/v1/planting-records/' + id
    const url = new URL(process.env.VUE_APP_API_URL + path)

    /* 共通処理 */
    return super.doFetch(decodeURI(url.href), 'GET')
  }
}

export default new PlantingRecordsApi()
